import { Event, View } from 'react-big-calendar';
import { ModelWithValuationData } from '../../services/models.types';

export interface ModelsCalendarProps {
  viewUserIds: number[];
  models: ModelWithValuationData[];
  isLoading: boolean;
  onSelectEvent?: (model: ModelWithValuationData) => void;
  onOpenPreview?: (model: ModelWithValuationData) => void;
  onEventDrop?: (modelId: number, newDueDate: string) => void;
  /** Hide built-in toolbar when using external CalendarToolbar */
  hideToolbar?: boolean;
  /** Controlled date from parent (for external toolbar) */
  controlledDate?: Date;
  /** Controlled view from parent (for external toolbar) */
  controlledView?: View;
  /** Callback when date changes (for external toolbar) */
  onDateChange?: (date: Date) => void;
  /** Callback when view changes (for external toolbar) */
  onViewChange?: (view: View) => void;
  /** When false, Google Calendar vacation events are hidden from the calendar */
  showGoogleVacationEvents?: boolean;
  /** Opens create-task flow when a day cell is double-clicked */
  onDayDoubleClick?: (date: Date) => void;
  /** Opens workboard task detail/edit when a task event is clicked */
  onWorkboardTaskSelect?: (taskId: number, occurrenceDate: string) => void;
}

export interface CalendarEvent extends Event {
  resource: ModelWithValuationData;
}

export interface GoogleCalendarEvent {
  summary: string;
  start: {
    date?: string;
    dateTime?: string;
  };
  end: {
    date?: string;
    dateTime?: string;
  };
}

export interface VacationCalendarEvent extends Event {
  resource: GoogleCalendarEvent;
  isGoogleVacationEvent: true;
}

/** Synthetic row rendered as the “N more vacations” control (not from Google Calendar). */
export interface VacationToggleCalendarEvent extends Event {
  resource: { weekKey: string };
  isVacationToggleEvent: true;
}

export type CalendarSortEvent = {
  start?: Date;
  end?: Date;
  allDay?: boolean;
  group?: string | null;
};

export type CalendarSortEventsArgs = {
  evtA: CalendarSortEvent;
  evtB: CalendarSortEvent;
};

export type WorkboardTaskCalendarEventResource = {
  workboard_task_id: number;
  occurrence_id: number | null;
  occurrence_date: string;
  display_date: string;
  status: string;
  assignee_ids: number[];
  task_manager_ids: number[];
  is_recurring: boolean;
  is_waiting: boolean;
  is_skipped: boolean;
};

export type WorkboardTaskApiEvent = {
  summary: string;
  start: { date?: string };
  end: { date?: string };
  isWorkboardTaskEvent: true;
  resource: WorkboardTaskCalendarEventResource;
};

export interface WorkboardTaskCalendarEvent extends Event {
  resource: WorkboardTaskCalendarEventResource;
  isWorkboardTaskEvent: true;
}

export const isWorkboardTaskCalendarEvent = (event: Event): event is WorkboardTaskCalendarEvent =>
  (event as WorkboardTaskCalendarEvent).isWorkboardTaskEvent === true;
